import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKeyboard, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'react-bootstrap';

import ShadeFormOptions from './ShadeFormOptions';
import Money from '../../../Parts/Money';
import { quickShadeFunction } from '../../QuoteObjectExtensions.ts';
import store from '../../../Store';
import { selectIsPsAdmin } from '../../../Store/user/userPermissions';
import PriceErrors from '../../PriceErrors';
import { SelectAssembly } from '../../../Store/entities/assemblies';
import apiCalls from '../../../PowerShadesAPIFunctions';
import { AssemblyViewModelFromAssemblyStore } from '../../../Store/entities/assemblies/types';

/* eslint class-methods-use-this: "off",
react/sort-comp: "off" */
class ShadeForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			errors: this.getErrors(props.shade),
			msrp: this.props.shade.val('msrp'),
			isPsAdmin: false,
			pulse: 0
		};

		this.fetchPrice = this.fetchPrice.bind(this);
		this.checkErrors = this.checkErrors.bind(this);
		this.shadeId = this.props.shade.data().id;
		this.shadeAssembly = this.props.quoteData.shadeAssemblies.Items
			.find((shade) => shade.sequence_id === props.shade.sequenceId);
		this.rerender = this.props.quoteData.UI.renderPage.bind(this);
		this.boundQuickShadeFunction = this.localQuickShadeFunction.bind(this);
		this.reprice = this.props.quoteData.RePriceSingleRow;
		this.fetchPrice();
	}

	getErrors(shade) {
		const shadeErrors = shade.getErrors(shade, true);
		return shadeErrors;
	}

	localQuickShadeFunction(event) {
		quickShadeFunction(
			event,
			this.shadeAssembly,
			this.rerender,
			this.reprice,
			this.props.quoteData.quote.ID
		);
	}

	componentDidMount() {
		const { getState } = store;
		const state = getState();

		const isPsAdmin = selectIsPsAdmin(state);
		this.setState({ isPsAdmin });
		document.addEventListener('keydown', this.boundQuickShadeFunction, false);
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.boundQuickShadeFunction, false);
		this.setState({ pulse: 0 });
	}

	fetchPrice() {
		const { shade } = this.props;

		const self = this;

		if (!shade.isUnlocked()) {
			return;
		}

		if (this.isFetchingPrice ?? false) return;

		const currentErrorsy = this.getErrors(self.props.shade, true);
		if (currentErrorsy.length > 0) {
			this.setState({
				errors: [
					...currentErrorsy
				],
				msrp: 0
			});
			return;
		}

		this.isFetchingPrice = true;
		const data = shade.data();
		data.tube_pricing_override = data.TubePricingOverride;
		data.motor_pricing_override = data.MotorPricingOverride;

		const assembly = SelectAssembly(this.props.quoteData.QuoteId,data.sequence_id)(store.getState())
		const assyVM = AssemblyViewModelFromAssemblyStore(assembly);
		apiCalls.calculateAssemblyPriceNew(assyVM, this.props.quoteData.QuoteId, "indoor")
			.then(({ data }) => {
				if (data.constructor === "".constructor) {
					const spotIndexA = data.indexOf('{"success"');
					const spotIndexB = data.indexOf('{"msrp"');

					let spotIndex = spotIndexA > spotIndexB ? spotIndexB : spotIndexA;

					if (spotIndexA > spotIndexB) {
						spotIndex = spotIndexB;
						spotIndex = spotIndexB === -1 ? spotIndexA : spotIndex;
					} else {
						spotIndex = spotIndexA;
						spotIndex = spotIndexA === -1 ? spotIndexB : spotIndex;
					}
					const cleanData = data.substring(spotIndex);
					data = JSON.parse(cleanData);
				}

				const price = data;

				if (price.errors && price.errors.length > 0) {
					const newErrors = price?.pricingData?.errors ?? price.errors;
					const currentErrors = this.getErrors(self.props.shade);

					this.setState({
						errors: [
							...newErrors,
							...currentErrors
						],
						msrp: 0
					});
				} else {
					self.props.shade.clearErrors();

					this.setState({
						msrp: price.msrp,
						errors: this.getErrors(self.props.shade)
					});
				}
			})
			.finally(() => {
				self.isFetchingPrice = false;
			});
	}

	onChange(args) {
		this.props.onChange(args);
	}

	checkErrors() {
		const errors = this.getErrors(this.props.shade);

		const originalErrors = this.state.errors;

		if (!((errors.length === originalErrors.length)
			&& errors.every((val, index) => val === originalErrors[index])
		)) {
			this.setState({ errors });
		}
	}

	render() {
		!this.props.newShade && this.props.quoteData.UI.setRenderPause();

		const {
			quote, shade, quoteType
		} = this.props;

		const { msrp } = this.state;
		const multiplier = this.props.quoteData.Money.currencyMultiplier;

		const errors = this.state.errors.map((err) => (

			<div key={`error-'${err}`} className="error" style={{ width: '100%' }}>
				{err}
				<br />
			</div>
		));

		const pulseTimer = () => {
			const pulsing = setInterval(() => {
				this.setState({ pulse: this.state.pulse + 1 });
				if (this.state.pulse > 3) {
					clearInterval(pulsing);
				}
			}, 3000);
		};
		
		if (this.state.pulse === 0) {
			pulseTimer();
		}

		/* eslint react/jsx-one-expression-per-line: "off" */
		const hotkeyInfo = (
			<div className="local-bootstrap">
				<Row>
					<Col>
						<Row>
							<Col className="text-start"><kbd>Ctrl</kbd> + <kbd>Shift</kbd> + <kbd>Q</kbd></Col>
							<Col className="text-end">Quick Shade Base Command</Col>
						</Row>
						<div className="text-muted mt-2 small-text">&emsp;&emsp;This is the pre-req command for a base shade.
							This command will not overwrite any existing properties (if selected).
							It will fill out all needed properties besides shade type, motor type,
							and header options. If this command is not run before the header command, it
							will run by itself.
						</div>
					</Col>
				</Row>
				<Row>
					<Col><h5 className={`text-${quoteType} text-center mt-1`}>Shade Types</h5></Col>
					<Row>
						<Col>
							<Row>
								<Col className="mt-2 text-center"><kbd>Ctrl</kbd> + <kbd>Shift</kbd> + <kbd>I</kbd></Col>
							</Row>
							<Row className="mt-2">
								<Col className="text-center">Quick Manual Shade</Col>
							</Row>
							<Row className="text-muted mt-2 small-text">
								<Col>
									This command changes a shade to manual spring pull.
								</Col>
							</Row>
						</Col>
						<Col>
							<Col className="mt-2 text-center"><kbd>Ctrl</kbd> + <kbd>Shift</kbd> + <kbd>M</kbd></Col>
							<Row className="mt-2">
								<Col className="text-center">Quick Motorized Shade</Col>
							</Row>
							<Row className="text-muted mt-2 small-text">
								<Col>
									This command changes a shade to motorized low voltage li-ion with wall charger.
								</Col>
							</Row>
						</Col>
					</Row>
				</Row>
				<Row>
					<Col>
						<Row>
							<Col><h5 className={`text-${quoteType} text-center mt-1`}>Headers</h5></Col>
						</Row>
						<Row className="text-muted small-text">
							<Col>
								&emsp;&emsp;If the pre req command was not ran and no shade type was selected,
								the pre req command will execute and default to motorized.
							</Col>
						</Row>
					</Col>
					
					<Row>
						<Col>
							<Row>
								<Col className="mt-2 text-center"><kbd>Ctrl</kbd> + <kbd>Shift</kbd> + <kbd>F</kbd></Col>
							</Row>
							<Row className="mt-2">
								<Col className="text-center">Quick Fascia Command</Col>
							</Row>
							<Row className="text-muted mt-2 small-text">
								<Col>
									This command changes a shade to 3&quot; black fascia header with end-caps.
								</Col>
							</Row>
						</Col>
						<Col>
							<Row>
								<Col className="mt-2 text-center"><kbd>Ctrl</kbd> + <kbd>Shift</kbd> + <kbd>X</kbd></Col>
							</Row>
							<Row className="mt-2">
								<Col className="text-center">Quick OG Cassette Command</Col>
							</Row>
							<Row className="text-muted mt-2 small-text">
								<Col>
									This command changes a shade to an OG (Fabric Insert) Anodized Cassette.
								</Col>
							</Row>
						</Col>
					</Row>
					<Row>
						<Col>
							<Row>
								<Col className="mt-2 text-center"><kbd>Ctrl</kbd> + <kbd>Shift</kbd> + <kbd>C</kbd></Col>
							</Row>
							<Row className="mt-2">
								<Col className="text-center">Quick Fabric Wrapped Cassette Command</Col>
							</Row>
							<Row className="text-muted mt-2 small-text">
								<Col>
									This command changes a shade to a Black Fabric Wrapped Cassette.
								</Col>
							</Row>
						</Col>
						<Col>
							<Row>
								<Col className="mt-2 text-center"><kbd>Ctrl</kbd> + <kbd>Shift</kbd> + <kbd>S</kbd></Col>
							</Row>
							<Row className="mt-2">
								<Col className="text-center">Quick Square Cassette Command</Col>
							</Row>
							<Row className="text-muted mt-2 small-text">
								<Col>
									This command changes a shade to a Anodized Square Cassette.
								</Col>
							</Row>
						</Col>
					</Row>
					<Row>
						<Col>
							<Row>
								<Col className="mt-2 text-center"><kbd>Ctrl</kbd> + <kbd>Shift</kbd> + <kbd>O</kbd></Col>
							</Row>
							<Row className="mt-2">
								<Col className="text-center">Quick Open Roll Command</Col>
							</Row>
							<Row className="text-muted mt-2 small-text">
								<Col>
									This command changes a shade to a Open Roll shade with black hardware and plastic
									end-caps.
								</Col>
							</Row>
						</Col>
					</Row>
				</Row>
			</div>
		);

		return (
			<>
				{this.state.isPsAdmin ? (
					<span
						onClick={() => {
							ROOT.alert({
								text: hotkeyInfo,
								quoteType,
								icon: 'info',
								title: 'Admin Hotkeys',
								oneButton: true,
								smallIcon: false,
							});
						}}
						onFocus={() => {
							ROOT.alert({
								text: hotkeyInfo,
								quoteType,
								icon: 'info',
								title: 'Admin Hotkeys',
								oneButton: true,
								smallIcon: false,
							});
						}}
					>
						<FontAwesomeIcon
							className={this.state.pulse < 3 ? 'pulse-icon' : ''}
							icon={faKeyboard}
							style={{ marginRight: '1em' }}
						/>
						<FontAwesomeIcon
							className={this.state.pulse < 3 ? 'pulse-icon' : ''}
							icon={faInfoCircle}
						/>
					</span>
				) : null}
				{shade ? (
					<ShadeFormOptions
						quoteType={quoteType}
						newShade={this.props.newShade}
						onOptionChange={this.fetchPrice}
						shade={shade}
						quote={quote}
						onChange={this.props.onChange}
						quoteData={this.props.quoteData}
						checkErrors={this.checkErrors}
					/>
				) : null}

				{this.props.newShade ? null : errors.length > 0 ? (
					errors
				) : (
					<PriceErrors quoteId={this.props.quoteData.QuoteId} msrp={msrp} error_messages={errors ?? ""} />
				)}
			</>
		);
	}
}

export default ShadeForm;
